import { gql } from '@apollo/client';

export const USER_FIELDS = gql`
  fragment UserFields on User {
    id
    username
    name
    firstName
    phoneNumber
    talkedWithYogi
    profilePictureUrl
    major
    classYear
    privacy {
      displayPicture
      directoryInfo
      msgEmail
      push
      facebook
      instagram
      linkedin
      twitter
      snapchat
    }
    canImpersonate
    profile {
      admin
    }
    isFirstLogin
    duringProfilePictureApproval
    facebook
    instagram
    linkedin
    twitter
    snapchat
  }
`;
